import { ExpenseModel } from "../../reduxToolkit/expensesSlice";
import { present } from "../util/present";

/**
 * The existing expenses a draft may be linked onto. Mirrors the intent of the
 * server-side matcher's candidate set (PlaidTransactionMatcher::loadCandidates):
 * real, incident-assigned expenses in the same membership. We intentionally do
 * NOT exclude expenses that already carry a Plaid payment — a real expense can
 * receive more than one linked charge (e.g. a payment plan). Submitted expenses
 * are likewise included on purpose: a bank charge can post after the claim was
 * filed, and the backend matcher (loadCandidates) does not filter submitted_at.
 *
 * Pure and side-effect free so it can be unit tested directly.
 */
export function selectLinkCandidates(
  expenses: ExpenseModel[],
  draft: ExpenseModel,
): ExpenseModel[] {
  return expenses.filter((e) =>
    e.id !== draft.id &&
    e.is_draft !== true &&
    !present(e.deleted_at) &&
    present(e.incident_id) &&
    e.membership_id === draft.membership_id
  )
}
